<div class="d-flex justify-content-center mt-2">
    <ngb-alert [dismissible]="false">{{ message }}</ngb-alert>
</div>
